(() => {
  'use strict';
  const dialog = document.getElementById('yc-signup');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  // Folder pages can be embedded; only the top-level storefront owns the popup.
  if (window.self !== window.top) return;
  const preview = dialog.dataset.preview === 'true' || new URLSearchParams(location.search).get('yc_signup_preview') === '1';
  if (!preview && dialog.dataset.enabled !== 'true') return;
  const form = dialog.querySelector('form');
  const email = form.elements.email, phone = form.elements.phone;
  const button = form.querySelector('[type="submit"]');
  const status = dialog.querySelector('.status');
  const statusRow = dialog.querySelector('[data-status-row]');
  const dismissKey = 'yc-signup-dismissed-until';
  let busy = false, completed = false, previousFocus;
  const setStatus = (message) => { status.textContent = message; statusRow.hidden = !message; };
  const resetConsent = () => {
    button.textContent = 'Enter';
    phone.setCustomValidity('');
    setStatus('');
  };
  function open() {
    if (dialog.open || busy) return;
    form.reset(); resetConsent(); completed = false;
    email.disabled = false; phone.disabled = false;
    previousFocus = document.activeElement;
    dialog.showModal();
    if (preview) setStatus('Design preview only — no information will be saved.');
  }
  function rememberDismissal() {
    if (!preview) { try { localStorage.setItem(dismissKey, String(Date.now() + 7 * 86400000)); } catch (_) {} }
  }
  function close() { dialog.close(); }
  dialog.querySelector('.klaviyo-close-form').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => { rememberDismissal(); previousFocus?.focus?.(); });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-yc-signup-open]')) { event.preventDefault(); open(); }
  });
  form.addEventListener('input', () => { if (!busy) resetConsent(); });
  function normalizePhone(value) {
    const compact = value.replace(/[\s().-]/g, '');
    // US/Canada national format is the storefront default; preserve explicit international prefixes.
    if (/^[2-9]\d{2}[2-9]\d{6}$/.test(compact)) return '+1' + compact;
    if (/^1[2-9]\d{2}[2-9]\d{6}$/.test(compact)) return '+' + compact;
    return /^\+[1-9]\d{7,14}$/.test(compact) ? compact : null;
  }
  async function subscribe(emailAddress, phoneNumber, list) {
    // Explicitly subscribe EMAIL ONLY. Phone is stored on the profile, without SMS consent.
    const subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    const attributes = { email: emailAddress, subscriptions };
    if (phoneNumber) attributes.phone_number = phoneNumber;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(dialog.dataset.company)}`, {
        method: 'POST', credentials: 'omit', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: { custom_source: 'YOSSI CORP. — Windows signup', profile: { data: { type: 'profile', attributes } } },
          relationships: { list: { data: { type: 'list', id: list } } }
        } })
      });
      if (response.status !== 202) throw new Error('Subscription was not accepted.');
    } finally { clearTimeout(timeout); }
  }
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy) return;
    if (completed) { close(); return; }
    if (!form.reportValidity()) return;
    const address = email.value.trim(), rawPhone = phone.value.trim();
    const number = rawPhone ? normalizePhone(rawPhone) : '';
    if (!number) {
      phone.setCustomValidity('Enter a 10-digit US/Canada number, or include + and your country code for other countries.');
      phone.reportValidity(); return;
    }
    // The approved design can be reviewed without transmitting any contact data.
    if (preview) {
      setStatus('Preview complete — no information was sent.');
      completed = true; button.textContent = 'Close'; return;
    }
    busy = true; button.disabled = true; email.disabled = true; phone.disabled = true;
    button.textContent = 'Sending…'; setStatus('');
    try {
      await subscribe(address, number, dialog.dataset.emailList);
      completed = true;
      setStatus('Thank you.');
      button.textContent = 'Close'; rememberDismissal();
    } catch (_) {
      setStatus('Signup could not be confirmed. Please try again.');
      button.textContent = 'Enter';
    } finally {
      busy = false; button.disabled = false;
      if (!completed) { email.disabled = false; phone.disabled = false; }
    }
  });
  function eligible() {
    if (/\/cart|\/checkout/.test(location.pathname + decodeURIComponent(location.search))) return false;
    try { if (Number(localStorage.getItem(dismissKey)) > Date.now()) return false; } catch (_) {}
    return true;
  }
  if (preview || new URLSearchParams(location.search).get('signup') === '1') open();
  else if (eligible()) {
    const startedAt = Date.now();
    let shownOnThisPage = false;
    function showOnce() {
      if (shownOnThisPage || !eligible()) return;
      shownOnThisPage = true;
      open();
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (event.relatedTarget === null && event.clientY <= 0 && Date.now() - startedAt >= 5000) showOnce();
      });
    } else {
      // Touch browsers do not expose a reliable exit-intent event.
      setTimeout(showOnce, 5000);
    }
  }
})();
